import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import memexfunctions from "./plugins/functions"
import Dexie from "dexie"
import 'material-icons/iconfont/material-icons.scss';
import axios from 'axios';
import VueGeolocation from 'vue-browser-geolocation';
import 'vue-md-player/dist/vue-md-player.css'
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.min.css'
import device from "vue-device-detector"
Vue.use(device)

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(require('vue-moment'));
const db = new Dexie('memex');

db.version(1).stores({
  mediaFiles: '++id,name,type,mediatype,blob,size'
});
Object.defineProperty(Vue.prototype, '$indexdb', { value: db });


Vue.use(memexfunctions);
Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$axios', { value: axios });


Vue.use(VueGeolocation);



delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import wysiwyg from "vue-wysiwyg-lite";


Vue.use(wysiwyg, {
  forcePlainTextOnPaste: true,
  toolbarPosition: 'bottom',
  hideModules: { "underline": true,"orderedList":true,"removeFormat":true,"separator":true, "image":true},
  image: {
    uploadURL: `${process.env.VUE_APP_ROOT_API}/uploadImage`,
    dropzoneOptions: {
      method: 'POST',
      headers: {
        'x-access-token': 'Bearer ' + store.getters.getAccessToken
      },
    }
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
